export const COPY_TEXT_SHOW_TIME = 2000;

export const copyText = {
  success: 'Copied!',
  error: 'Not copied!',
};
